module.exports = __webpack_public_path__ + "static/media/piechart-placeholder-header.59046568.png";